import { render, staticRenderFns } from "./Pbill.vue?vue&type=template&id=41991924&"
import script from "./Pbill.vue?vue&type=script&lang=js&"
export * from "./Pbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports